














import { Vue, Component } from 'vue-property-decorator';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { isWeiXin } from '@/common/ts/common';
import { getBaseInfo } from './api';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  cover = '';
  activeTab = 0;
  baseInfo: any = {};

  async created() {
    const retBaseInfo = await getBaseInfo();
    this.baseInfo = retBaseInfo.data;
    if (retBaseInfo.data.activityId) {
      this.$addPv(retBaseInfo.data.activityId);
      this.cover = retBaseInfo.data.banner;
    }
    window.userInfoChange = () => {
      location.reload();
    };
    // 设置pv和分享
    this.$appShareInfo({
      title: '网信“十四五” 请您来建言',
      url: location.href,
      subtitle: '',
      classId: -1,
      id: -1,
      image: this.cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '网信“十四五” 请您来建言',
        subtitle: '',
        image: this.cover,
      });
    }
  }
}
